export default "__VITE_ASSET__hLzyK215__"